import React, {useRef, useState} from 'react'
import {getDetailById} from "../../../services/serviceOffer";
import {Button, Modal} from "antd";
import OfferPrint from "./OfferPrint";
import {useReactToPrint} from "react-to-print";


const OfferPrintContainer = ({offerId, popChange}) => {

    const [offer, setOffer] = useState()
    const [printModal, setPrintModal] = useState(false)

    const printRef = useRef()


    const handlePrintClick = () => {
        popChange()
        getDetailById(offerId)
            .then(({data}) => {
                setOffer(data)
                setPrintModal(!printModal)
            })
    }

    const handlePrintEvent = useReactToPrint({
        content: () => printRef.current
    })

    const changeModalStatus = () => setPrintModal(!printModal)

    return (
        <React.Fragment>
            <Button
                type={"link"}
                onClick={handlePrintClick}
            >
                Yazdır
            </Button>

            {
                printModal ?
                    <Modal
                        open={printModal}
                        onCancel={changeModalStatus}
                        title={'Teklif Ön İzleme'}
                        footer={
                            <Button
                                type={'primary'}
                                onClick={handlePrintEvent}
                            >
                                Yazdır
                            </Button>
                        }
                        bodyStyle={{
                            minWidth: '100%'
                        }}
                        style={{
                            minWidth: '85%'
                        }}
                    >
                        <OfferPrint
                            ref={printRef}
                            offer={offer}
                        />
                    </Modal>
                    : null
            }
        </React.Fragment>
    )
}
export default OfferPrintContainer